<template>
  <main class="guard-menu-skeleton">
    <div class="guard-menu-skeleton__header">
      <div class="guard-menu-skeleton__title"></div>
      <div class="guard-menu-skeleton__sub"></div>
    </div>
    <div class="guard-menu-skeleton__search-wrap">
      <div class="guard-menu-skeleton__search-bar"></div>
    </div>
    <div class="guard-menu-skeleton__grid">
      <div
        class="guard-menu-skeleton__card"
        v-for="i in 8"
        :key="i"
      ></div>
    </div>
  </main>
</template>

<script>
export default {
  name: "MenuSkeleton",
};
</script>

<style scoped lang="scss">
@import '../styles';

.guard-menu-skeleton {
  @include guard-panel-help;

  &__header {
    margin-bottom: 1.2rem;
    @include guard-responsive-width;
    text-align: center;
  }
  &__title { @include guard-skeleton($dark: false, $radius: $guard-radius-sm); width: 60%; height: 28px; margin: 0 auto 8px; }
  &__sub { @include guard-skeleton($dark: false, $radius: $guard-radius-sm); width: 45%; height: 16px; margin: 0 auto; }

  &__search-wrap {
    @include guard-responsive-width;
    margin: 0 auto 1.5rem;
  }
  &__search-bar { @include guard-skeleton($dark: false, $radius: $guard-radius-pill); width: 100%; height: 46px; }

  &__grid { @include guard-tiles-grid; }
  &__card {
    @include guard-skeleton($dark: false, $radius: $guard-radius-lg);
    aspect-ratio: 1 / 1;
  }
}
</style>